<template>
    <Home fit="cover">  <!-- andere Option "Contain" -->
        <template #picture>
            <!-- background -->
            <source media="(orientation: portrait)" srcset="../assets/img/zdf_logo_phonePortrait.png">
            <source media="(orientation: landscape)" srcset="../assets/img/zdf_logo_phoneLandscape.png">
        </template>
        <template #headline>Tschernobyl</template>
        <template #subline>Die Atom-Katastrophe und ihre Folgen</template>
        <!--<template #text>
            <p>Hallo. Ich bin ein kleiner Blindtext. Und zwar schon so lange ich denken kann. Es war nicht leicht zu verstehen, was es bedeutet, ein blinder Text zu sein: Man ergibt keinen Sinn. Wirklich keinen Sinn.</p>
            <p>Man wird zusammenhangslos eingeschoben und rumgedreht – und oftmals gar nicht erst gelesen. Aber bin ich allein deshalb ein schlechterer Text als andere? Na gut, ich werde nie in den Bestsellerlisten stehen. Aber andere Texte schaffen das auch nicht. Und darum stört es mich nicht besonders blind zu sein. Und sollten Sie diese Zeilen noch immer lesen, so habe ich als kleiner Blindtext etwas geschafft, wovon all die richtigen und wichtigen Texte meist nur träumen.</p>
        </template>-->
        <template #update>
            April 2026

        </template>
    </Home>
</template>

<script>
    export default {
        name: 'home',
        babylonState: {

            camera: {
                position: [-1,1,90],
                target: [-10, 10, 0],
                stopOnClick: false,
                useAutoRotationBehavior: true,
                radiusLimits:[5,100],
            },

            tschernobyl:{
                root:{

                    Typo: {visible: false},
                    Text_Labels: {visible: false},
                    
                    AKW: {
                        GroßerTurm: {},
                        KleinerTurm: {visible: false},
                        Reaktor_kaputt: {visible: false},
                    },
                    
                    Strahl_2: {visible: false},

                    Sarkophag: {visible: false},

                    NSC: {visible:false},

                    Maus_GRP:{
                        visible: true,
                        scale:[0],
                        position:[26.5,4.7,2],
                        pickable: false,
                        //billboardMode:7,
                        
                        Maus:{
                            renderingGroupId:3,
                            billboardMode:27,
                            pickable: false,
                            //scale: [.5,.5,.5],
                        },
                    },
                },
            },

        },

        babylonReady: function ()
        {

        },
        // methods: {
        //     next: function () {
        //         this.$tracking.navigationClick('Start');
        //         this.$eventBus.$emit('nextPage');
        //     }
        // },
    }
</script>

<style lang="scss">

    .home {

        // change default opacity: 0.35
        .home__background {

            opacity: 0;
        }
        // change default object-position: unset (50% 50%)  / Für Portrait ist nur der x-Wert relevant, für Landscape nur der y-Wert. / Einheit entweder in "%" oder "px"
        .home__background img.o-fit {

            //object-position: 50% 0%;
            //
            //@media (orientation: landscape) {
            //
            //    object-position: 0% 50%;
            //}
        }
    }

</style>